import { render, staticRenderFns } from "./VisibilityBadge.vue?vue&type=template&id=d48b90f6&scoped=true&"
import script from "./VisibilityBadge.vue?vue&type=script&lang=js&"
export * from "./VisibilityBadge.vue?vue&type=script&lang=js&"
import style0 from "./VisibilityBadge.vue?vue&type=style&index=0&id=d48b90f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48b90f6",
  null
  
)

export default component.exports